import { render, staticRenderFns } from "./PosSettings.vue?vue&type=template&id=7eff6180"
import script from "./PosSettings.vue?vue&type=script&lang=js"
export * from "./PosSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports